import React, { PureComponent } from 'react'
import { Grid, ListItem, Table, TableHead, TableBody, TableCell, TableRow } from '@material-ui/core'
import {
  EditableTextField,
  EditableSelect,
  EditableNumericInput,
  EditableSwitch,
} from '../common/EditableComponents'
import MenuItem from '@material-ui/core/MenuItem/MenuItem'
import { weightPerUnitOptions } from '../../utils/constants'

export default class AddPricingTemplate extends PureComponent {
  onChangePricing = (key, index) => (value) => {
    this.props.onChangePricing(key, index, 'price')({ target: { value } })
  }

  onChangeEnabled = (key, index) => (event) => {
    this.props.onChangePricing(key, index, 'active', true)(event)
  }

  render() {
    const { data = {}, editMode = false } = this.props

    const {
      id = '',
      priceBreaks = [],
      priceRanges = [],
      unitType = 'grams',
      weightPerUnit = '',
      name = '',
      active = false,
    } = data

    const pricingList = unitType === 'grams' ? priceRanges : priceBreaks

    const selectedWeightPerUnit = weightPerUnitOptions.find(
      (option) => option.value === weightPerUnit,
    )

    return (
      <Grid container className="paper-page">
        <ListItem>
          <Grid container>
            <Grid className="labelField" item xs={12} sm={4} md={4} lg={4}>
              Name
            </Grid>
            <Grid className="editField" item xs={12} sm={8} md={8} lg={8}>
              <EditableTextField
                valueToRender={name}
                editMode={editMode}
                value={name}
                onChange={this.props.onChange('name')}
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem>
          <Grid container>
            <Grid className="labelField" item xs={12} sm={4} md={4} lg={4}>
              Status
            </Grid>
            <Grid className="editField" item xs={12} sm={8} md={8} lg={8}>
              <EditableSelect
                valueToRender={active ? 'Active' : 'Inactive'}
                editMode={editMode}
                value={active}
                onChange={this.props.onChange('active')}
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </EditableSelect>
            </Grid>
          </Grid>
        </ListItem>
        <ListItem>
          <Grid container>
            <Grid className="labelField" item xs={12} sm={4} md={4} lg={4}>
              Unit of Measurement
            </Grid>
            <Grid className="editField" item xs={12} sm={8} md={8} lg={8}>
              <EditableSelect
                valueToRender={unitType === 'grams' ? 'Grams' : 'Units'}
                editMode={editMode && !id}
                value={unitType}
                onChange={this.props.onChange('unitType')}
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="grams">Grams</MenuItem>
                <MenuItem value="units">Each</MenuItem>
              </EditableSelect>
            </Grid>
          </Grid>
        </ListItem>
        {unitType === 'units' ? (
          <ListItem>
            <Grid container>
              <Grid className="labelField" item xs={12} sm={4} md={4} lg={4}>
                Weight Per Unit
              </Grid>
              <Grid className="editField" item xs={12} sm={8} md={8} lg={8}>
                <EditableSelect
                  valueToRender={selectedWeightPerUnit && selectedWeightPerUnit.label}
                  editMode={editMode && !id}
                  value={weightPerUnit}
                  onChange={this.props.onChange('weightPerUnit')}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  {weightPerUnitOptions.map((option, i) => {
                    return (
                      <MenuItem key={i} value={option.value}>
                        {option.label}
                      </MenuItem>
                    )
                  })}
                </EditableSelect>
              </Grid>
            </Grid>
          </ListItem>
        ) : null}
        <ListItem>
          <Grid container>
            <Grid className="labelField" item xs={12} sm={4} md={4} lg={4}>
              Tier Pricing
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={8}>
              <Table className="pricing_template">
                <TableHead>
                  <TableCell>Unit Name</TableCell>
                  {unitType === 'units' ? <TableCell>Display Name</TableCell> : null}
                  {unitType === 'units' ? <TableCell>Qty</TableCell> : null}
                  <TableCell style={{ minWidth: 120 }}>Price</TableCell>
                  {unitType === 'units' ? <TableCell>Enabled</TableCell> : null}
                </TableHead>
                <TableBody>
                  {pricingList.map((pricing, i) => {
                    const name =
                      unitType === 'grams'
                        ? (pricing.weightTolerance && pricing.weightTolerance.name) || ''
                        : pricing.name
                    const qty =
                      unitType === 'grams'
                        ? pricing.weightTolerance && pricing.weightTolerance.weightValue
                        : pricing.quantity

                    return (
                      <TableRow key={i}>
                        <TableCell>{name || ''}</TableCell>
                        {unitType === 'units' ? (
                          <TableCell>
                            <EditableTextField
                              valueToRender={pricing.displayName}
                              editMode={editMode}
                              value={pricing.displayName}
                              onChange={this.props.onChangePricing(
                                'priceBreaks',
                                i,
                                'displayName',
                                false,
                              )}
                            />
                          </TableCell>
                        ) : null}
                        {unitType === 'units' ? <TableCell>{qty}</TableCell> : null}
                        <TableCell>
                          {/* <EditableTextField 
                                                    type="number"
                                                    valueToRender={toCurrencyLocale(pricing.price || 0)}
                                                    editMode={editMode}
                                                    value={pricing.price}
                                                    onChange={this.props.onChangePricing(unitType == 'grams' ? 'priceRanges' : 'priceBreaks', i)}
                                                /> */}
                          <EditableNumericInput
                            placeholder="Price"
                            valueToRender={pricing.price || 0}
                            value={pricing.price || 0}
                            className="numeric-material-input"
                            mobile={false}
                            onChange={this.onChangePricing(
                              unitType === 'grams' ? 'priceRanges' : 'priceBreaks',
                              i,
                            )}
                            min={0}
                            precision={2}
                            editMode={editMode}
                          />
                        </TableCell>
                        {unitType === 'units' ? (
                          <TableCell>
                            <EditableSwitch
                              valueToRender={pricing.active ? 'Enabled' : 'Disabled'}
                              checked={pricing.active}
                              onChange={this.onChangeEnabled('priceBreaks', i)}
                              editMode={editMode}
                            />
                          </TableCell>
                        ) : null}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </ListItem>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PricingTemplate/AddPricingTemplate.js